import styled from "@emotion/styled";

const Shell = styled.main`
  display: flex;
  flex-direction: column;
  grid-area: d;
  grid-column: 2 / 4;
  height: 100%;
  min-height: 0;
  overflow: hidden;
  width: 100%;
  z-index: 0;

  @media (max-width: 768px) {
    grid-column: 1;
  }
`;

export default { Shell };
